import React, { useState, useEffect } from 'react'
import CardGripMapSemanal from './CardGripMapSemanal';
import CardGripMapMensual from './CardGripMapMensual';
import CardGripMapSedes from './CardGripMapSedes';
import { TabGroup, TabList, Tab, TabPanels, TabPanel } from '@tremor/react';
import axios from 'axios';

const apiUrlAddresses = `${process.env.REACT_APP_API_URL}/addres`;

const Dashpage = () => {
  const [sedes, setSedes] = useState([]);
  const [sedeSeleccionada, setSedeSeleccionada] = useState(''); // '' = todas las sedes

  useEffect(() => {
    const getSedes = async () => {
      try {
        const res = await axios.get(apiUrlAddresses);
        setSedes(res.data);
      } catch (error) {
        console.error('Error al obtener las sedes:', error);
      }
    };
    getSedes();
  }, []);

  return (
    <main className='min-h-screen bg-gradient-to-br from-blue-50 via-cyan-50 to-teal-50 py-8 px-4'>
      <div className="max-w-7xl mx-auto">
        {/* Header con gradiente */}
        <div className="bg-white rounded-2xl shadow-xl p-6 mb-6 border-b-4 border-blue-500">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
            <div className="flex items-center gap-4">
              <div className="bg-gradient-to-br from-blue-500 to-cyan-600 p-4 rounded-xl shadow-lg">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
              </div>
              <div>
                <h1 className='text-3xl font-bold text-gray-800'>Dashboard</h1>
                <p className="text-gray-600">Estadísticas y análisis de pedidos</p>
              </div>
            </div>

            <div className="w-full lg:w-auto">
              <label className="block text-sm font-bold text-gray-700 mb-2">Filtrar por sede:</label>
              <select
                className="w-full lg:w-72 bg-white border-2 border-blue-300 text-gray-800 px-4 py-3 rounded-xl font-semibold shadow-md hover:border-blue-500 focus:ring-2 focus:ring-blue-200 transition"
                onChange={(e) => setSedeSeleccionada(e.target.value)}
                value={sedeSeleccionada}
              >
                <option value="">📊 Todas las sedes</option>
                {sedes.map((sede) => (
                  <option key={sede.id_direccion} value={sede.id_direccion}>
                    {sede.nombre_sede || `${sede.direccion} - ${sede.localidad}`}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <TabGroup className='mt-6'>
          <TabList className="bg-white rounded-xl shadow-lg p-2 border-2 border-blue-200">
            <Tab className="!text-gray-700 !font-bold data-[selected]:!bg-gradient-to-r data-[selected]:!from-blue-500 data-[selected]:!to-cyan-600 data-[selected]:!text-white data-[selected]:!rounded-lg data-[selected]:!shadow-md transition-all">📅 Datos por día</Tab>
            <Tab className="!text-gray-700 !font-bold data-[selected]:!bg-gradient-to-r data-[selected]:!from-blue-500 data-[selected]:!to-cyan-600 data-[selected]:!text-white data-[selected]:!rounded-lg data-[selected]:!shadow-md transition-all">📊 Datos por mes</Tab>
            <Tab className="!text-gray-700 !font-bold data-[selected]:!bg-gradient-to-r data-[selected]:!from-blue-500 data-[selected]:!to-cyan-600 data-[selected]:!text-white data-[selected]:!rounded-lg data-[selected]:!shadow-md transition-all">🏢 Ranking de sedes</Tab>
          </TabList>

          <TabPanels>
            <TabPanel>
              <CardGripMapSemanal sedeSeleccionada={sedeSeleccionada} />
            </TabPanel>
            <TabPanel>
              <CardGripMapMensual sedeSeleccionada={sedeSeleccionada} />
            </TabPanel>
            <TabPanel>
              <CardGripMapSedes />
            </TabPanel>
          </TabPanels>
        </TabGroup>
      </div>
    </main>
  )
}

export default Dashpage